import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { TrInputsModule } from '@toro/common/shared/components';
import { AgreementComponent } from './agreement.component';
import { HttpService } from '@toro/common/shared/services/http/http.service';
import { TrWrapperTwoColumnsModule } from '@toro/common/shared/components';
import { HubLogoModule, TrLoadingOverlayModule, SvgIconModule } from '@toro/common/shared/components';
import { RegisterIntentComponent } from './components/register-intent/register-intent.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        RouterModule,
        HubLogoModule,
        SvgIconModule,
        TrInputsModule,
        HttpClientModule,
        ReactiveFormsModule,
        TrLoadingOverlayModule,
        TrWrapperTwoColumnsModule,
    ],
    declarations: [AgreementComponent, RegisterIntentComponent],
    providers: [HttpService, HttpClient],
})

export class AgreementModule { }
